import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteAudioFailure,
  deleteAudioStart,
  deleteAudioSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpDeleteAudio } from "../../../services/audio";

function* deleteAudio({ payload }) {
  const { id, callback } = payload;
  const response = yield call(httpDeleteAudio, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteAudioSuccess(raw));

    if (callback) {
      callback();
    }
  } else {
    yield put(deleteAudioFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onDeleteAudio() {
  yield takeLatest(deleteAudioStart, deleteAudio);
}
